import React from 'react';
import {Divider, HStack, VStack} from "native-base";
import {t} from "../../../../../../../services/i18n";
import {isMobile} from "../../../../../../../services/Helpers";
import {Colors} from "../../../../../../../styles/Colors";
import {GlobalStyleAttributes} from "../../../../../../../styles/GlobalStyles";
import AppText from "../../../../../../common/AppText";
import InfoTooltip from "../../../../../../common/InfoTooltip";
import AutoMessages from "./AutoMessages";
import AutoMessagesGroup from "./AutoMessagesGroup";
import {autoMessageTypes} from "../../SettingsConfig";

const TrialAutoMessages = () => (
    <VStack>
        {!isMobile &&
        <HStack alignItems={'center'} mb={'0.5rem'}>
            <AppText fontSize={GlobalStyleAttributes.fonts.standard16} boldFont>{t('autoMessageTrialLbl')}</AppText>
            <InfoTooltip title={t('trial-auto-message-tooltip')}/>
        </HStack>}
        <AutoMessagesGroup
            messageType={autoMessageTypes.BEFORE_TRIAL_CLASS}
            filterRow={(item) => item.auto_actions?.action === 'LEAD_ATTENDANCE' && item.before_after === 'BEFORE' && item.session_type === null && item.auto_action_type !== 'TASK'}
            groupLabel={t('trial-session-before-section-lbl')}
            header={t('beforeTrialSessionLbl')}
            subheader={t('beforeTrialSessionTxt')}
            periodAmountTextBefore={t('before-trial-session-period-before')}
            periodAmountTextAfter={t('before-trial-session-period-after')}
            sessionType={null}
        />
        <Divider w={'100%'} bg={Colors.borderColor} my={'1rem'}/>
        <AutoMessagesGroup
            messageType={autoMessageTypes.AFTER_TRIAL_CLASS}
            filterRow={(item) => item.auto_actions?.action === 'LEAD_ATTENDANCE' && item.before_after === 'AFTER' && item.session_type === null && item.auto_action_type !== 'TASK'}
            groupLabel={t('trial-session-after-section-lbl')}
            header={t('afterTrialSessionLbl')}
            subheader={t('afterTrialSessionTxt')}
            periodAmountTextBefore={t('after-trial-session-period-before')}
            periodAmountTextAfter={t('after-trial-session-period-after')}
            sessionType={null}
        />
        <Divider w={'100%'} bg={Colors.borderColor} my={'1rem'}/>
        <VStack space={'0.5rem'}>
            <AppText
                mediumFont
                style={{
                color: Colors.newDesign.darkGrey,
                fontSize: GlobalStyleAttributes.fonts.heading4,
                textTransform: 'uppercase',
            }}>{t('trial-session-missed-section-lbl')}</AppText>
            <AutoMessages
                messageType={autoMessageTypes.MISSED_TRIAL_SESSION}
                header={t('missedTrialSessionLbl')}
                subheader={t('missedTrialSessionTxt')}
                periodAmountTextBefore={t('trial-session-period-before')}
                periodAmountTextAfter={t('trial-session-period-after')}
                sessionType={null}
            />
        </VStack>
    </VStack>
)

export default TrialAutoMessages;
